import axios from 'axios'

const getAddress = async (cep) => {
	cep = cep.replace('-', '')
	return axios.get(`https://viacep.com.br/ws/${cep}/json/`)
}

export { getAddress }
